import {NavLink} from "react-router-dom";
import {buildLinkUrl, buildRoute} from "@router/RouterUtils";
import {AppRoute} from "@router/RoutingModels";
import {useUser} from "@lib/User/UserHooks";
import {useMainWallet} from "@lib/Wallet/WalletHooks";
import {MenuOpenedIcon} from "@components/Icons/MenuOpenedIcon";
import {MenuClosedIcon} from "@components/Icons/MenuClosedIcon";
import {Dispatch, SetStateAction} from "react";
import {useCmsHeader, useCmsMainNavigation, useCmsSettings} from "@store/AppContextStore";
import {useProjectTranslations} from "@i18n/i18nUtils";
import {assetFullPath, formatPoints} from "@commons/Utils";
import {UserMenu} from "@components/Layout/Private/UserMenu";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";

interface PrivateHeaderProps {
    mobileMenuOpened: boolean;
    setMobileMenuOpened: Dispatch<SetStateAction<boolean>>;
}

const PrivateHeader = ({mobileMenuOpened, setMobileMenuOpened}: PrivateHeaderProps) => {

    const {
        data: user,
        isLoading: userLoading,
    } = useUser();

    const {
        data: wallet,
        isLoading: walletLoading,
    } = useMainWallet();

    const cmsSettings = useCmsSettings();
    const headerCms = useCmsHeader();
    const mainNavigation = useCmsMainNavigation();

    const {t} = useProjectTranslations();

    return (
        <>
            <header className="layout__header" style={{overflow: mobileMenuOpened ? "visible" : "hidden"}}>

                <div className="layout__header__primary">
                    <div className="container full-bleed">
                        <div className="logo">
                            <NavLink to={buildRoute(AppRoute.HOME)}>
                                <img src={assetFullPath(headerCms?.image?.[0].src ?? "")}
                                     alt={cmsSettings?.appTitle ?? ""}/>
                            </NavLink>
                        </div>
                        {!userLoading && user &&
                            <div className="account">
                                {!walletLoading && !!wallet &&
                                    <div className={"points"}>
                                        <span
                                            className={"tp-l light color-primary regular"}>{t("header:user:points")}: </span>
                                        <span className={"tp-l"}>{formatPoints(wallet.number)}</span>
                                    </div>
                                }
                                <UserMenu/>
                            </div>
                        }
                    </div>
                </div>

                {!!mainNavigation && mainNavigation.length > 0 &&
                    <div className="layout__header__secondary">
                        <div className="container full-bleed">
                            <nav className={`nav ${mobileMenuOpened ? "is-mobile-opened" : "is-mobile-closed"}`}>
                                <div className="mobile-trigger" onClick={() => setMobileMenuOpened(!mobileMenuOpened)}>
                                    {mobileMenuOpened
                                        ?
                                        <div className="opened">
                                            <MenuOpenedIcon/>
                                        </div>
                                        :
                                        <div className="closed">
                                            <MenuClosedIcon/>
                                        </div>
                                    }
                                </div>
                                <ul className={`${mobileMenuOpened ? "mobile-opened" : "mobile-closed"}`}>
                                    {mainNavigation.map((link, i) =>
                                        <li key={`nav_link_${i}`}>
                                            <NavLink
                                                to={buildLinkUrl(link.scope)}
                                                target={link.href?.target ?? undefined}
                                                end
                                            >
                                                {link.title}
                                                <span className=""><ChevronRightIcon/></span>
                                            </NavLink>
                                        </li>
                                    )}
                                </ul>
                            </nav>
                        </div>
                    </div>
                }

            </header>

            {!walletLoading && !!wallet &&
                <div className="points mobile-points">
                    <span className={""}>{t("header:user:points")}: </span>
                    <span className={""}>{formatPoints(wallet.number)}</span>
                </div>
            }
        </>
    );

}

export default PrivateHeader;